import React from "react";
import style from "./loader.module.css"
import LoadingSpinner from "../LoadingSpinner";

export function Loader(props) {
    return (<>
        {props.loading &&
            <div className={style.backdrop}>
                <LoadingSpinner/>

            </div>}
    </>)
}
export function LoaderCircle(props) {
    return (<>
        {props.loading &&
                <div className={style.spinner2}>
                </div>
           }
    </>)
}